// frontend/user/src/components/article-card.tsx
// 论坛(LNMX9) + 个人主页(OhKgp)共用文章卡(2 列瀑布流)。
// hideAuthor=true 时隐藏作者头像+昵称(个人主页用),保留分类·点赞。
import { cn } from '@dogdisk/shared'
import type { ArticleFeedItem } from '../_lib/article-api'
import { resourceUrl } from '../_lib/resource-node-pref'

export function ArticleCard({
  article,
  onClick,
  hideAuthor = false,
  testId = 'LNMX9-article-card',
}: {
  article: ArticleFeedItem
  onClick: () => void
  hideAuthor?: boolean
  testId?: string
}) {
  const hasCover = Boolean(article.cover_thumb_url)
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className="mb-2 block w-full break-inside-avoid overflow-hidden rounded-xl border border-surface-150 bg-white text-left"
    >
      {hasCover && (
        <img src={resourceUrl(article.cover_thumb_url!)} alt="" loading="lazy" className="w-full object-cover" />
      )}
      <div className={cn('flex flex-col gap-2', hasCover ? 'px-3 pt-2.5 pb-3' : 'px-3.5 py-4')}>
        <p className={cn('line-clamp-2 font-semibold text-ink', hasCover ? 'text-[14px]' : 'text-[18px]')}>
          {article.title}
        </p>
        {article.excerpt && (
          <p className="line-clamp-2 text-[12px] leading-[1.4] text-ink-mute">{article.excerpt}</p>
        )}
        <div className="flex items-center gap-1.5 pt-1 text-[11px] text-ink-muted">
          {!hideAuthor && (
            <>
              {article.owner_avatar ? (
                <img src={resourceUrl(article.owner_avatar)} alt="" className="h-5 w-5 shrink-0 rounded-full object-cover" />
              ) : (
                <span className="h-5 w-5 shrink-0 rounded-full bg-surface-200" />
              )}
              <span className="truncate">
                {article.owner_nickname}
              </span>
            </>
          )}
          {article.category_name && (
            <>
              {!hideAuthor && <span className="shrink-0 text-ink-faint">·</span>}
              <span className="shrink-0">{article.category_name}</span>
            </>
          )}
          <span className="flex-1" />
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0 text-ink-mute">
            <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z" />
          </svg>
          <span className="shrink-0 text-ink-mute">{article.like_count}</span>
        </div>
      </div>
    </button>
  )
}
